/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function updateOverlayHeaderClasses() {
    var headerWrapper = document.querySelector('[data-header-wrapper]');
    var firstSectionOverlayHeader = document.querySelector('.main-content > .shopify-section.section-overlay-header:first-of-type');

    document.body.classList.toggle('has-header-transparent', !!(headerWrapper && headerWrapper.hasAttribute('data-header-transparent')));
    document.body.classList.toggle('has-first-section-overlay-header', !!firstSectionOverlayHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateOverlayHeaderClasses);
  } else {
    updateOverlayHeaderClasses();
  }

  document.addEventListener('shopify:section:load', updateOverlayHeaderClasses);
  document.addEventListener('shopify:section:unload', updateOverlayHeaderClasses);

  function headerOverlayIsOpen() {
    return !!(
      document.documentElement.hasAttribute('data-scroll-locked') ||
      document.querySelector('header-drawer.is-open') ||
      document.body.classList.contains('rebuy-cart-visible') ||
      document.body.classList.contains('rebuy-modal-visible')
    );
  }

  function clearScrollLockGap() {
    if (!headerOverlayIsOpen()) return;
    if (document.body.style.getPropertyValue('padding-right') === '0px') return;

    document.body.style.setProperty('padding-right', '0px', 'important');
  }

  function scheduleClearScrollLockGap() {
    setTimeout(clearScrollLockGap);
    setTimeout(clearScrollLockGap, 50);
  }

  window.addEventListener('theme:scroll:lock', scheduleClearScrollLockGap);
  window.addEventListener('resize', scheduleClearScrollLockGap);
  document.addEventListener('theme:resize', scheduleClearScrollLockGap);

  if (document.body) {
    new MutationObserver(scheduleClearScrollLockGap).observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style', 'data-scroll-lock-filled-gap'],
    });
  }

  new MutationObserver(scheduleClearScrollLockGap).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-scroll-locked'],
  });

  function headerSearchHasFocus(wrapper) {
    var activeElement = document.activeElement;

    return !!(
      wrapper &&
      activeElement &&
      activeElement !== document.body &&
      wrapper.contains(activeElement) &&
      activeElement.closest('.header__search-bar')
    );
  }

  function headerSearchIsActive(wrapper) {
    return !!(
      headerSearchHasFocus(wrapper) ||
      (wrapper && wrapper.querySelector('predictive-search[open], predictive-search[loading]'))
    );
  }

  function headerOverlayIsOpen(wrapper) {
    return !!(
      document.querySelector('header-drawer.is-open') ||
      document.body.classList.contains('rebuy-cart-visible') ||
      document.body.classList.contains('rebuy-modal-visible')
    );
  }

  function syncHeaderOverlayState() {
    var wrapper = document.querySelector('[data-header-wrapper]');
    if (!wrapper) return;

    if (!wrapper.hasAttribute('data-catori-transparent')) {
      if (!wrapper.hasAttribute('data-header-transparent')) return;
      wrapper.setAttribute('data-catori-transparent', '');
    }

    wrapper.toggleAttribute('data-header-search-active', headerSearchIsActive(wrapper) || headerOverlayIsOpen(wrapper));

    wrapper.setAttribute('data-header-transparent', '');

    updateOverlayHeaderClasses();
  }

  function bindHeaderOverlayState() {
    var wrapper = document.querySelector('[data-header-wrapper]');
    if (!wrapper || wrapper.dataset.catoriOverlayBound) return;
    if (!wrapper.hasAttribute('data-header-transparent')) return;

    wrapper.dataset.catoriOverlayBound = 'true';

    var drawer = document.querySelector('header-drawer');
    if (drawer) {
      new MutationObserver(syncHeaderOverlayState).observe(drawer, {attributes: true, attributeFilter: ['class']});
    }

    new MutationObserver(syncHeaderOverlayState).observe(document.body, {attributes: true, attributeFilter: ['class']});

    wrapper.addEventListener('focusin', syncHeaderOverlayState);
    wrapper.addEventListener('focusout', function () {
      setTimeout(syncHeaderOverlayState);
    });

    wrapper.addEventListener('input', function (event) {
      if (!event.target.closest('.header__search-bar')) return;
      syncHeaderOverlayState();
    });

    wrapper.querySelectorAll('predictive-search').forEach(function (ps) {
      new MutationObserver(syncHeaderOverlayState).observe(ps, {attributes: true, attributeFilter: ['open', 'loading']});
    });

    syncHeaderOverlayState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindHeaderOverlayState);
  } else {
    bindHeaderOverlayState();
  }

  document.addEventListener('shopify:section:load', bindHeaderOverlayState);

  function bindMobileHeaderPriceSync() {
    document.querySelectorAll('[data-price-mobile-header]').forEach(function (mobilePrice) {
      if (mobilePrice.dataset.priceSyncBound) return;

      var source = document.getElementById(mobilePrice.id.replace(/-mobileheader$/, ''));
      if (!source) return;

      mobilePrice.dataset.priceSyncBound = 'true';

      var observer = new MutationObserver(function () {
        mobilePrice.innerHTML = source.innerHTML;
      });
      observer.observe(source, {childList: true, subtree: true, characterData: true});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindMobileHeaderPriceSync);
  } else {
    bindMobileHeaderPriceSync();
  }

  document.addEventListener('theme:product-info:loaded', bindMobileHeaderPriceSync);

  function getSelectedVariantForSubmitButton(button) {
    const productInfo = button.closest('product-info');

    if (productInfo) {
      let selectedVariant = productInfo.querySelector('variant-selects [data-selected-variant]');
      if (!selectedVariant) {
        selectedVariant = productInfo.querySelector('[data-selected-variant]');
      }

      if (selectedVariant && selectedVariant.textContent.trim()) {
        try {
          return JSON.parse(selectedVariant.textContent);
        } catch (error) {
          // Fall through to id input fallback.
        }
      }
    }

    const form = button.closest('product-form') || button.closest('form');
    const idInput = form && form.querySelector('input.product-variant-id[name="id"], input[name="id"]');
    if (!idInput || !idInput.value) return null;

    return {
      id: Number(idInput.value),
      available: idInput.getAttribute('data-available') !== 'false' && !idInput.disabled,
      price: Number(idInput.getAttribute('data-price') || 0),
    };
  }

  function formatProductSubmitPrice(price) {
    const format = window.theme && (window.theme.moneyWithoutCurrencyFormat || window.theme.moneyFormat);
    let formatted;

    if (window.theme && typeof window.theme.formatMoney === 'function') {
      formatted = window.theme.formatMoney(price, format);
    } else {
      formatted = '$' + (price / 100).toFixed(2);
    }

    return formatted.replace(/\$\s+/g, '$').replace(/\$/g, '$\u200A');
  }

  function setTextContentIfChanged(element, value) {
    if (!element || element.textContent === value) return;

    element.textContent = value;
  }

  function syncProductSubmitButton(button, fallbackText) {
    const label = button.querySelector('[data-add-to-cart-label], [data-add-to-bag-text]');
    const price = button.querySelector('[data-add-to-cart-price], .product__submit__price');
    const separator = button.querySelector('[data-add-to-cart-separator], .product__submit__separator');
    const simpleText = button.querySelector('[data-add-to-cart-text]');
    const variant = getSelectedVariantForSubmitButton(button);
    const strings = window.theme && window.theme.strings ? window.theme.strings : {};
    const addToCartText = strings.addToCart || 'Add to cart';
    let labelText = fallbackText || addToCartText;

    if (!label) {
      setTextContentIfChanged(simpleText, labelText);
      return;
    }

    const addToBagText = label.getAttribute('data-add-to-bag-text') || 'ADD TO BAG';

    if (variant) {
      if (variant.available) {
        labelText = button.getAttribute('data-preorder') === 'true' ? strings.preOrder || labelText : addToBagText;
      } else {
        labelText = strings.soldOut || labelText;
      }
    } else if (fallbackText && fallbackText !== addToCartText) {
      labelText = fallbackText;
    } else {
      labelText = strings.unavailable || labelText;
    }

    setTextContentIfChanged(label, labelText);

    if (!price || !separator) return;

    if (!variant || !variant.available) {
      price.setAttribute('hidden', 'hidden');
      separator.setAttribute('hidden', 'hidden');
      return;
    }

    if (!price.hasAttribute('data-catori-price-cents')) {
      price.setAttribute('data-catori-price-cents', String(variant.price));
    } else if (price.getAttribute('data-catori-price-cents') !== String(variant.price)) {
      const formattedPrice = variant.price === 0 ? strings.free || 'Free' : formatProductSubmitPrice(variant.price);
      price.setAttribute('data-catori-price-cents', String(variant.price));
      setTextContentIfChanged(price, formattedPrice);
    }

    price.removeAttribute('hidden');
    separator.removeAttribute('hidden');
  }

  function syncProductAddToBagLabel(root) {
    (root || document).querySelectorAll('.product__submit__add').forEach(function (button) {
      syncProductSubmitButton(button);
    });
  }

  function patchProductFormSubmitButton() {
    const ProductForm = window.customElements && window.customElements.get('product-form');

    if (!ProductForm || ProductForm.prototype.catoriSubmitButtonPatched) return;

    ProductForm.prototype.catoriSubmitButtonPatched = true;
    ProductForm.prototype.toggleSubmitButton = function (disable, text) {
      const strings = window.theme && window.theme.strings ? window.theme.strings : {};
      const addToCartText = strings.addToCart || 'Add to cart';
      const normalizedText = text || addToCartText;
      const hasStructuredCta = this.submitButton.querySelector('[data-add-to-cart-label], [data-add-to-bag-text]');
      const formWrapper = this.closest('[data-form-wrapper], .form__wrapper');
      // Newsletter sold-out UI hides ATC via CSS that requires [disabled]. Keep it during
      // variant-loading so the button does not flash "Sold Out" between sold-out variants.
      const isSoldOutNotificationVisible =
        !!formWrapper &&
        formWrapper.classList.contains('show-product-notification') &&
        formWrapper.classList.contains('variant--soldout');
      const isVariantLoadingState = disable !== false && normalizedText === addToCartText && hasStructuredCta;
      const normalizedDisable =
        disable !== false && (!isVariantLoadingState || isSoldOutNotificationVisible);

      this.submitButton.toggleAttribute('disabled', normalizedDisable);
      if (isVariantLoadingState && !isSoldOutNotificationVisible) {
        this.submitButton.setAttribute('aria-disabled', 'true');
      } else {
        this.submitButton.removeAttribute('aria-disabled');
      }
      syncProductSubmitButton(this.submitButton, normalizedText);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      patchProductFormSubmitButton();
      syncProductAddToBagLabel();
    });
  } else {
    patchProductFormSubmitButton();
    syncProductAddToBagLabel();
  }

  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined('product-form').then(function () {
      patchProductFormSubmitButton();
      syncProductAddToBagLabel();
    });
  }

  document.addEventListener('variant-change', function (event) {
    syncProductAddToBagLabel(event.target);
  });

  document.addEventListener('variantChange', function (event) {
    syncProductAddToBagLabel(event.target);
  });

  document.addEventListener('theme:product-info:loaded', function (event) {
    syncProductAddToBagLabel(event.target);
  });

  if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function () {
      syncProductAddToBagLabel();
    });
  }

  function getStampedBadgeHideTarget(stampedEl) {
    return (
      stampedEl.closest('.product-item__rating, .product-app--desktop, .product__block') ||
      stampedEl
    );
  }

  function hideEmptyStampedBadges() {
    document.querySelectorAll('.stamped-product-reviews-badge').forEach(function (stampedEl) {
      var badge = stampedEl.querySelector('.stamped-badge');
      var reviewsNode = stampedEl.querySelector('[data-reviews]');
      var hideTarget = getStampedBadgeHideTarget(stampedEl);

      if (!badge && !reviewsNode) {
        hideTarget.classList.remove('product-stamped-rating--hidden', 'product-item__rating--hidden');
        return;
      }

      var reviewCount = reviewsNode ? parseInt(reviewsNode.getAttribute('data-reviews'), 10) : null;
      var ratingValue = badge
        ? parseFloat(String(badge.getAttribute('data-rating') || '0').replace(',', '.'))
        : null;
      var hasReviews =
        (reviewCount !== null && !isNaN(reviewCount) && reviewCount > 0) ||
        (ratingValue !== null && !isNaN(ratingValue) && ratingValue > 0);

      hideTarget.classList.toggle('product-stamped-rating--hidden', !hasReviews);
      hideTarget.classList.toggle('product-item__rating--hidden', !hasReviews);
    });
  }

  function scheduleHideEmptyStampedBadges() {
    [200, 600, 1200].forEach(function (delay) {
      setTimeout(hideEmptyStampedBadges, delay);
    });
  }

  function reloadStampedCollectionBadges() {
    var attempt = 0;

    function tryLoadBadges() {
      if (window.StampedFn && typeof window.StampedFn.loadBadges === 'function') {
        window.StampedFn.loadBadges();
        scheduleHideEmptyStampedBadges();
        return;
      }

      attempt += 1;
      if (attempt < 10) {
        setTimeout(tryLoadBadges, 200);
      }
    }

    tryLoadBadges();
  }

  var stampedBadgeReloadTimer;

  function stampedBadgeNodeWasAdded(node) {
    if (!node || node.nodeType !== 1) return false;

    if (node.matches && node.matches('.stamped-product-reviews-badge')) return true;
    if (node.querySelector && node.querySelector('.stamped-product-reviews-badge')) return true;

    return false;
  }

  function bindStampedCollectionBadgeReload() {
    document
      .querySelectorAll('collection-component, [data-section-type="collection"], [data-product]')
      .forEach(function (container) {
      if (container.dataset.stampedBadgeObserverBound) return;

      container.dataset.stampedBadgeObserverBound = 'true';

      new MutationObserver(function (mutations) {
        var hasNewBadges = mutations.some(function (mutation) {
          return Array.from(mutation.addedNodes).some(stampedBadgeNodeWasAdded);
        });

        if (hasNewBadges) {
          scheduleStampedCollectionBadgeReload();
        }

        if (
          mutations.some(function (mutation) {
            return mutation.type === 'attributes' && mutation.target.matches('.stamped-badge, [data-reviews]');
          })
        ) {
          hideEmptyStampedBadges();
        }
      }).observe(container, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-rating', 'data-reviews']});
    });
  }

  function scheduleStampedCollectionBadgeReload() {
    clearTimeout(stampedBadgeReloadTimer);
    stampedBadgeReloadTimer = setTimeout(function () {
      bindStampedCollectionBadgeReload();
      reloadStampedCollectionBadges();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindStampedCollectionBadgeReload();
      scheduleHideEmptyStampedBadges();
    });
  } else {
    bindStampedCollectionBadgeReload();
    scheduleHideEmptyStampedBadges();
  }

  document.addEventListener('shopify:section:load', bindStampedCollectionBadgeReload);
  document.addEventListener('shopify:collection:update', scheduleStampedCollectionBadgeReload);
  document.addEventListener('theme:product-info:loaded', scheduleHideEmptyStampedBadges);
  window.addEventListener('popstate', scheduleStampedCollectionBadgeReload);

  function bindScrollLockTouchScroll() {
    document.querySelectorAll('[data-scroll-lock-scrollable]').forEach(function (el) {
      if (el.dataset.touchScrollBound) return;

      el.dataset.touchScrollBound = 'true';
      el.addEventListener(
        'touchmove',
        function (event) {
          event.stopPropagation();
        },
        {passive: true}
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindScrollLockTouchScroll);
  } else {
    bindScrollLockTouchScroll();
  }

  document.addEventListener('shopify:section:load', bindScrollLockTouchScroll);
  document.addEventListener('theme:drawer:open', function () {
    setTimeout(bindScrollLockTouchScroll, 100);
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
